import { Divider } from 'antd';
import React from 'react';

import { Gap } from '@common/components';
import {
  ProviderButton,
  SignInEmailFormRecordType,
  SignInPasswordForm,
} from '@identity/components';

type UserConfirmationType = {
  setTitle: (param: string) => void;
  worksAuthInfo: SignInEmailFormRecordType;
};

export function SignInPageUserConfirmation({
  worksAuthInfo,
  setTitle,
}: UserConfirmationType) {
  const { memberships, user, email } = worksAuthInfo;

  if (!memberships.length) {
    setTitle('Your user account is not linked to an entity.');
    return (
      <div>
        Get in touch to learn more about how you can manage your flexible
        workforce, the modern way.
      </div>
    );
  }

  setTitle(`Welcome back, ${user.firstName}!`);

  const passwordMemberships = memberships.filter((mm) => {
    return (
      mm.entity.authProviders.filter(
        (p) => p.provider === 'password' && p.active && p.visible
      ).length === 1
    );
  });

  const ssoMemberships = memberships.filter((mm) => {
    return (
      mm.entity.authProviders.filter(
        (p) =>
          p.provider !== 'password' &&
          p.provider !== 'trusted_okta' &&
          p.active &&
          p.visible
      ).length > 0
    );
  });

  const getEntityNameOrCode = (entity: { code: string; name: string }) => {
    if (user.internalTrustedUser && entity.code) {
      return entity.code;
    }

    return entity.name;
  };

  return (
    <Gap vertical fullWidth>
      {passwordMemberships.length > 0 && (
        <SignInPasswordForm
          email={email}
          user={user}
          memberships={passwordMemberships}
        />
      )}

      {ssoMemberships.length > 0 && (
        <>
          <Divider plain>
            {passwordMemberships.length > 0 && 'Or '}
            SSO to
          </Divider>

          {ssoMemberships.map((m) => {
            return m.entity.authProviders.map(
              (p) =>
                p.provider !== 'password' &&
                p.provider !== 'trusted_okta' && (
                  <ProviderButton
                    key={p.id}
                    authProvider={p}
                    membershipId={m.id}
                    fullWidth
                  >
                    {getEntityNameOrCode(m.entity)}
                  </ProviderButton>
                )
            );
          })}
        </>
      )}
    </Gap>
  );
}
